import styled, { createGlobalStyle } from "styled-components";

import JLREmericWebExtraLight from "./fonts/JLREmericWeb-ExtraLight.woff";
import JLREmericExtraLight from "./fonts/JLREmeric-ExtraLight.woff2";
import JLREmericRegular from "./fonts/JLREmeric-Regular.woff2";
import JLREmericSemiBold from "./fonts/JLREmeric-SemiBold.woff2";

export const JLREmericWebExtraLightFont = createGlobalStyle`


@font-face {
  font-family: "JLREmericWebExtraLight";
  src: url(${JLREmericWebExtraLight}) format("woff");
  font-style: normal;
  font-display: auto;
}
`;

export const JLREmericExtraLightFont = createGlobalStyle`
@font-face {
  font-family: "JLREmericExtraLight";
  src: url(${JLREmericExtraLight}) format("woff2");
  font-style: normal;
  font-display: auto;
}
`;

export const JLREmericRegularFont = createGlobalStyle`
@font-face {
  font-family: "JLREmericRegular";
  src: url(${JLREmericRegular}) format("woff2");
  font-style: normal;
  font-display: auto;
}
`;

export const JLREmericSemiBoldFont = createGlobalStyle`
@font-face {
  font-family: "JLREmericSemiBold";
  src: url(${JLREmericSemiBold}) format("woff2");
  font-style: normal;
  font-display: auto;
}
`;

const H2 = {
  fontFamily: "Inter",
  fontSize: "24px",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "32px"
};

export const Navbar = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  img {
    width: 100%;
    height: 46px;
    flex-shrink: 0;
  }
`;

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 480px;
  margin: auto;
  min-height: 100vh;
  background-color: #fff;

  p {
    color: #202020;
    font-family: "Inter", sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 300;
    line-height: 24px;
  }

  a {
    text-decoration: underline;
    cursor: pointer;
  }

  .stores {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    img {
      cursor: pointer;
    }
  }

  .show-more {
    display: inline;
    text-decoration: underline;
    font-weight: bold;
    cursor: pointer;
  }
`;

export const JLRContainer = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;

  h1 {
    color: #000;
    text-align: center;
    font-family: "JLREmericWebExtraLight";
    font-size: 32px;
    font-style: normal;
    font-weight: 280;
    line-height: 40px;
  }

  p {
    color: #000 !important;
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 280;
    line-height: 24px; /* 150% */
    letter-spacing: 0.5px;
  }
`;

export const SectionContainer = styled.section`
  .section-logo {
    width: 100%;
    max-width: 297px;
    aspect-ratio: 297 / 79;
    height: auto;
    object-fit: contain;
  }
  border-bottom: 1px solid #d8d8d9;
  .title-bar {
    padding: 16px;
    background-color: ${({ customColor }) =>
      customColor ? customColor : "#523373"};

    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    h2 {
      ${H2}
      color: white;
    }
    img {
      cursor: pointer;
    }
  }
`;

export const SectionContent = styled.div`
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  h2 {
    ${H2}
    span {
      color: #ff6400;
    }
  }
`;

export const Footer = styled.footer`
  padding: 24px 16px 64px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;
  background-color: #000;

  .powered-by {
    font-family: "Inter";
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 32px;
  }

  p {
    font-family: "Inter";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 150% */
    letter-spacing: 0.5px;
    color: white;
  }

  img {
    width: 117px;
    height: 33.724px;
    object-fit: contain;
  }
`;

export const NextStepsContainer = styled.div`
  margin-top: -1px;
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 16px 0px;
  background-color: white;
  border-top: 1px solid #000;
  h2 {
    font-family: Inter;
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    line-height: 40px; /* 125% */
  }
`;

export const StepContainer = styled.div`
  padding: 32px 16px;
  h2 {
    margin-top: 16px;
    font-family: Inter;
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    line-height: 40px;
  }
  p {
    margin-top: 16px;
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 150% */
    letter-spacing: 0.5px;
    columns: #626262;
  }
  .pay-anywhere {
    margin: 24px auto;
    width: 100%;
    object-fit: contain;
  }
`;

export const CurvelogoContainer = styled.div`
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  .separator {
    height: 25px;
    object-fit: cover;
    width: 100%;
  }
  .title {
    font-family: Inter;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 40px;
  }

  .curve-logo {
    height: 32px;
    width: 152px;
  }
  .flags {
    display: flex;
    gap: 8px;
    img {
      height: 26px;
    }
  }
`;

export const StepNumber = styled.div`
  display: flex;
  width: 40px;
  padding: 8px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 360px;
  background: #f6f6f7;
`;

export const AppStoreLinks = styled.section`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 16px;

  img {
    cursor: pointer;
    margin-top: 24px;

    height: 50px;
  }
`;
